import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaEnvelope, FaPhoneAlt, FaGlobe, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import Select from "react-select";
import "./App.css";

function MedicalSearch() {
  const [personType, setPersonType] = useState("");
  const [illness, setIllness] = useState("");
  const [medicine, setMedicine] = useState("");
  const [result, setResult] = useState(null);

  // Custom styles for react-select
  const customStyles = {
    control: (base) => ({
      ...base,
      borderRadius: "6px",
      borderColor: "#ccc",
      padding: "2px",
      minHeight: "42px"
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999
    })
  };

  // Options
  const titleOptions = [
    { value: "Pilot", label: "Pilot" },
    { value: "Cabin Crew", label: "Cabin Crew" }
  ];

  const genericOptions = [
    { value: "Diabetes", label: "Diabetes" },
    { value: "Cold", label: "Cold" }
  ];

  const brandOptions = [
    { value: "Insulin", label: "Insulin" },
    { value: "Paracetamol", label: "Paracetamol" }
  ];

  // Search Logic
  const handleSearch = () => {
    if (!medicine) {
      setResult(null);
      return;
    }

    setResult({
      classification: "Aviation Policy",
      indication:
        "Detailed medical assessment required for selected condition.",
      resultText:
        "Medication use is permitted with caution. Monitor before flight."
    });
  };

  return (
    <div className="home">

      {/* HERO */}
      <section
        className="hero"
        style={{ backgroundImage: "url('/bg.jpg')" }}
      >
        <div className="overlay">
          <div className="navbar">
            <Link to="/" className="logo-link">
              <img
                src="/logos.svg"
                alt="The Safe Runway"
                className="logo-img"
              />
            </Link>
          </div>
        </div>
      </section>

      {/* SEARCH SECTION */}
      <section className="tools">
        <h2 className="tools-title">Medication Search</h2>

        <div className="search-container">

          <div className="form-row">

            {/* TITLE */}
            <div className="form-group">
              <label>Title</label>
              <Select
                options={titleOptions}
                placeholder="Select..."
                styles={customStyles}
                onChange={(selected) =>
                  setPersonType(selected?.value)
                }
              />
            </div>

            {/* GENERIC NAME */}
            <div className="form-group">
              <label>Generic Name</label>
              <Select
                options={genericOptions}
                placeholder="Select..."
                styles={customStyles}
                onChange={(selected) =>
                  setIllness(selected?.value)
                }
              />
            </div>

            {/* BRAND NAME */}
            <div className="form-group">
              <label>Brand Name</label>
              <Select
                options={brandOptions}
                placeholder="Select..."
                styles={customStyles}
                onChange={(selected) =>
                  setMedicine(selected?.value)
                }
              />
            </div>

          </div>

          <button className="search-btn" onClick={handleSearch}>
            Search
          </button>

          {/* RESULTS */}
          {result && (
            <div className="results-section">

              <h3 className="results-title">Medication Search Results</h3>
              <p className="results-subtitle">
                Showing guidelines for <strong>{personType}</strong> regarding{" "}
                <strong>{illness}</strong>
              </p>

              <div className="results-cards">

                <div className="result-card">
                  <h4>Classification</h4>
                  <p>{result.classification}</p>
                </div>

                <div className="result-card">
                  <h4>Indication</h4>
                  <p>{result.indication}</p>
                </div>

                <div className="result-card">
                  <h4>Results</h4>
                  <p>{result.resultText}</p>
                </div>

              </div>

            </div>
          )}

        </div>
      </section>

      {/* CONTACT */}
      <section className="contact">
              <h2>Contact Us</h2>
      
              <div className="contact-row">
      
                <a href="mailto:info@thesaferunway.com" className="contact-link">
                  <div className="contact-item">
                    <FaEnvelope className="contact-icon" />
                  </div>
                </a>
      
              <div className="contact-item">
        <a href="tel:+971503883438" className="contact-link">
          <FaPhoneAlt className="contact-icon" />
        </a>
      </div>
      
                <a
                  href="https://thesaferunway.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                  <div className="contact-item">
                    <FaGlobe className="contact-icon" />
                  </div>
                </a>
                <a
                  href="https://linkedIn.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                  <div className="contact-item">
                    <FaLinkedinIn className="contact-icon" />
                  </div>
                </a>
                <a
                  href="https://www.instagram.com/thesaferunway/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                  <div className="contact-item">
                    <FaInstagram className="contact-icon" />
                  </div>
                </a>
                <a
                  href="https://www.instagram.com/thesaferunway/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                  <div className="contact-item">
                    <FaYoutube className="contact-icon" />
                  </div>
                </a>
      
              </div>
            </section>

    </div>
  );
}

export default MedicalSearch;